import React from 'react';
import { Row, Col } from 'reactstrap';
import { connect } from 'react-redux';

// @ts-ignore
import StyledButton from 'flaivy-react/components/StyledButton';
import { toggleLoginModal as _toggleLoginModal } from '../shared/actions/login-modal.action';

import AuthenticatedWrapper from 'flaivy-react/components/AuthenticatedWrapper';

interface LoginToShowPricesProps extends React.PropsWithChildren {
  toggleLoginModal: () => void;
  className?: string;
}

const LoginToShowPrices: React.FC<LoginToShowPricesProps> = ({
  toggleLoginModal,
  children,
  className,
}) => {
  return (
    <AuthenticatedWrapper
      fallback={
        <Row
          className={`align-items-center g-0 text-sm loginToShowPrice ${
            className || ''
          }`}
        >
          <Col className="text-center p-2">
            <StyledButton onClick={toggleLoginModal}>Logga in</StyledButton>
          </Col>
        </Row>
      }
    >
      {children}
    </AuthenticatedWrapper>
  );
};

const mapDispatchToProps = {
  toggleLoginModal: _toggleLoginModal,
};

export default connect(null, mapDispatchToProps)(LoginToShowPrices);
